<template>
  <v-alert dark v-model="alertBar.status" color="primary" icon="mdi-clock-fast" border="left">
    <div class="title">{{alertBar.title}}</div>
    <div>Group Key: {{alertBar.group_key}}</div>
    <div>Permission Key:{{alertBar.permission_key}}</div>
  </v-alert>
</template>

<script>
export default {
  name: 'alertBar',
  data: () => ({
    alertBar: {}
  }),
  created () {
    this.alertBar = this.$store.state.alertBar
  }
}
</script>

<style scoped>

</style>
